import(/* webpackMode: "eager" */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/app/(notLogged)/page.tsx");
